"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _makeStyles = _interopRequireDefault(require("../styles/makeStyles"));

var _Spacing = _interopRequireDefault(require("../Spacing"));

var styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between'
    }
  };
};

exports.styles = styles;
var useStyles = (0, _makeStyles["default"])(styles);

var GalleryFigure = function GalleryFigure(_ref) {
  var className = _ref.className,
      children = _ref.children;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_Spacing["default"], {
    Component: "figure",
    className: (0, _classnames["default"])(classes.root, className),
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 8,
    marginRight: 8
  }, children);
};

GalleryFigure.propTypes = {
  /** Classes applied to the root component */
  className: _propTypes["default"].string,

  /** The content of the component */
  children: _propTypes["default"].node.isRequired
};
var _default = GalleryFigure;
exports["default"] = _default;